import React from 'react';
import ReactDOM from 'react-dom';
import { ExperienceProvider, ContextBuilder } from '@thd-nucleus/experience-context';
// ⚠ DEEP PATH, DELIBERATE — do not "tidy" this to the package barrel.
// `@thd-olt-functional/customer-information`'s barrel re-exports
// `hooks/useMembershipInformation`, which imports `@thd-nucleus/data-sources` →
// `@apollo/client`. This module is the fixed build entry, so importing the barrel
// here drags all 69 of those modules into the ENTRY chunk and undoes Sequence G,
// whose entire point was getting Apollo off the warm-while-closed path (see
// `hooks/useMessageHistory.jsx` and `queryLayer/QueryLayerBlock.jsx`).
// `dist/components/CustomerProvider` imports only react/prop-types/its own
// context, so this gives master's B2B fix with none of the weight.
// `warm-core-check.mjs` is what catches a regression here.
import { CustomerProvider } from '@thd-olt-functional/customer-information/dist/components/CustomerProvider';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { App } from './app/App';
import { getIsInIframe, waitForIdle } from './shared/utils/assistant-utils';

const { experienceContext } = ContextBuilder.client({
  expConfiguration: window?.__EXPERIENCE_PROPS__?.expConfiguration
});

// The loader's stylesheet ships as a non-blocking <link rel="preload"> (see
// postPlugin.js) so it never holds up the host PDP's first paint. Promote it to
// a real stylesheet on demand — App calls this once it determines (via the
// reactive excluded-pages config) that the page is actually compatible, so
// incompatible pages never activate it.
function activateStyles() {
  if (typeof document === 'undefined') return;
  document
    .querySelectorAll('link[data-magic-apron-css][rel="preload"]')
    .forEach((link) => link.setAttribute('rel', 'stylesheet'));
}

function renderApp(container) {
  const app = (
    <React.StrictMode>
      <ErrorBoundary name="magic-apron-assistant-loader">
        <ExperienceProvider value={experienceContext}>
          {/* MAG4-838: B2B shoppers saw wrong OOS state without a customer context. */}
          <CustomerProvider>
            <App activateStyles={activateStyles} />
          </CustomerProvider>
        </ExperienceProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

  // React 18/19 uses createRoot instead of render, but we want to maintain compatibility with React 16 for now.
  // It will check for createRoot and use it if available.
  if (typeof ReactDOM.createRoot === 'function') {
    ReactDOM.createRoot(container).render(app);
  } else {
    ReactDOM.render(app, container);
  }
}

// MAG4-850: the assistant already renders on the parent page, so a second
// instance inside a frame is never wanted — and checking here rather than in a
// component avoids the flicker of mounting and then bailing.
if (typeof BroadcastChannel !== 'undefined' && !getIsInIframe()) {
  waitForIdle(() => {
    const container = document.getElementById('magic-apron-loader');
    if (container) {
      renderApp(container);
    }
  });
}
